export const matchPath = (routes: string[], url: string): boolean => {
  const regexRoutes = routes.map(
    (route) =>
      // Handle corpid and groupId placeholders as wildcards
      new RegExp(`^${route.replace(/\[corpid\]|\[groupId\]/g, '[^/]+')}$`)
  );

  return regexRoutes.some((regex) => regex.test(url));
};
